import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { QuayBanCuaHang } from '../../models/store_stalls.model';
import { Logo } from '../../models/logo.model';
import { AuthenticationService } from '../../services/authentication.service';
import { UploadFileService } from '../../services/upload-file.service';
import { ProductService } from '../../services/product.service';
import { EmployeesService } from '../../services/employees.service';
import { CustomerService } from '../../services/customer.service';
import { JWTService } from '../../services/JWTService';
import { BillService } from '../../services/bill.service';
import { CuaHangbillFormatService } from '../../services/CuaHangbillFormat.service';
import { HangHoa } from '../../models/product.model';
import { KH_HCG } from '../../models/customer.model';
import { NhanVien } from '../../models/employees.model';
import { BgColors } from '../../models/bg_color.model';
import { ServerResponse } from '../../models/types';
import { HD } from '../../models/bill.model';
import { NotificationService } from '../../services/notification.service';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from '../../services/getLocalForage.service';
import { async } from 'q';
import { CurrencyService } from '../../services/currency.service';
import { SuKienGiaService } from '../../services/sukiengia.service';

@Component({
  selector: 'app-quayban',
  templateUrl: './quayban.component.html',
  styleUrls: ['./quayban.component.css'],
})

export class QuayBanComponent implements OnInit {


  checkbtnBanHang = true;
  checkUserQuanTri = true;
  _isChecked = false;
  checkSignIn = false;


  quayban: Array<QuayBanCuaHang> = new Array<QuayBanCuaHang>();
  valueInput: string;
  url: any;
  dataHH: Array<HangHoa> = new Array<HangHoa>();
  dataKH_CHG: Array<KH_HCG> = new Array<KH_HCG>();
  closeResult: string;
  logo: Logo = new Logo();
  colorBG: BgColors = new BgColors();
  messageError = '';
  mr: NgbModalRef;

  @ViewChild('contentLoading') private contentLoading;
  constructor(
    private authenticateService: AuthenticationService,
    private notificationService: NotificationService,
    private uploadFileService: UploadFileService,
    private hanghoaService: ProductService,
    private nhanvienService: EmployeesService,
    private currencyService: CurrencyService,
    private modalService: NgbModal,
    private jwtService: JWTService,
    private billService: BillService,
    private customerService: CustomerService,
    private customizeBillformatService: CuaHangbillFormatService,
    private getlocalconfig: GetLocalForageConFigService,
    private productService: ProductService,
    private sukiengiaService: SuKienGiaService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl + 'assets/images/Logo/';
    this.uploadFileService.getFileName()
      .then((res: Logo) => {
        console.log(res);
        this.logo.lg_content = res.lg_content;
        this.logo.lg_overall = res.lg_overall;
        this.logo.lg_start = res.lg_start;
      });
    console.log(this.logo);
    this.TPCloud_GetBGColor();
  }
  ngOnInit() {
  }

  async submitHouseCharge() {
    this.customerService.getCustomer_HCG()
      .then((result) => {
        const str = this.jwtService.enCryptData(result);
        this.getlocalconfig.getConfigLocalForage()
          .then(async result => {
            await localForage.setItem('_dsKHHCG', str);
          });
      })
      .catch(error => {
        console.log(error);
      });
  }

  async submitHangHoa() {
    const khuVuc: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
     this.hanghoaService.getProduct(khuVuc[0].MaKhuVuc)
      .then((result: Array<HangHoa>) => {
        this.dataHH = result;
      })
      .catch(err => {
        console.log(err);
      });
  }

  async submitNhanVien() {
    const cuaHang: NhanVien = JSON.parse(localStorage.getItem('_dtQBan'));
    await this.nhanvienService.getNhanVien(cuaHang[0].MaCH)
      .then((result: Array<NhanVien>) => {
        console.log(result);
        const str = this.jwtService.enCryptData(result);
        this.getlocalconfig.getConfigLocalForage()
        .then(async result => {
          localForage.setItem('_dsNV', str);
        })
      .catch(err => {
        console.log(err);
      });
  });
}

  async submitHTTT() {
    const cuaHang: NhanVien = JSON.parse(localStorage.getItem('_dtQBan'));
    await this.billService.getPayments(cuaHang[0].MaCH)
    .then((result) => {
      console.log('ket qua submitHTTT');
      console.log(result);
      const str = this.jwtService.enCryptData(result);
      console.log('Text da giai ma dc hay khong');
      this.getlocalconfig.getConfigLocalForage()
      .then(async result => {
        await localForage.setItem('_dsHTTT', str);
      });
    })
    .catch (error => {
      console.log(error);
    });
  }

  async submitGetCurrency() {
    await this.currencyService.getCurrency()
      .then(result => {
        console.log('Lấy dữ liệu tiền tệ thành công!');
      })
      .catch(err => {
        console.log(err);
      });
  }


  async submitBill(maCH: string) {
    await this.customizeBillformatService.GetBill(maCH)
    .then (result => {
      console.log(result[0]);
      const str = this.jwtService.enCryptData(result);
      this.getlocalconfig.getConfigLocalForage()
      .then(async res => {
        await localForage.setItem('_dsBill', str);
      });
    })
    .catch (error => {
      console.log(error);
    });
  }


  async submitQuayBan(contentError) {
    this.mr = this.modalService.open(this.contentLoading, { centered: true, backdrop: 'static' });
    await this.authenticateService.getMaQuay(this.valueInput)
      .then(async result => {
        await this.submitHTTT();
        await this.submitHangHoa();
        await this.submitNhanVien();
        await this.submitGetCurrency();
        await this.submitBill(result[0].MaCH);
        await this.submitSuKienGia(result[0].MaCH);
        await this.submitHouseCharge();
        this.notificationService.sendNotification();
        // await this.submitgetInvoiceToday(result[0].MaQuay);
        // localForage.getItem('_dsNV').then((data: string) => {
        //   if (data) {
        //     const test = data;
        //  const decry = this.jwtService.deCryptData(test);
        //  const obje = JSON.parse(decry);
        //  console.log(decry);
        //   }
        // });
        this.mr.dismiss();
      })
      .catch(err => {
        this.mr.dismiss();
        this.messageError = err.message;
        this.openMessageError(contentError);
      });
  }

  openMessageError(contentError) {
    if (this.messageError !== '') {
      this.modalService.open(contentError, { centered: true })
        .result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
   submitBanHang() {
     this.checkbtnBanHang = !this.checkbtnBanHang;
  }
  submitCauHinh() {
    localForage.getItem('_acceptKey').then((data: string) => {
      if (data) {
        this.authenticateService.redirectTPA(data);
      }
    });
  }

  submitBoQua() {
   this.checkbtnBanHang = !this.checkbtnBanHang;
  }

  async TPCloud_GetBGColor() {
    await localForage.getItem('_colorBG').then((result: any) => {
      console.log(JSON.parse(result));
      this.colorBG = JSON.parse(result);
    })
    .catch (err => {
      console.log('Lỗi');
    });
  }


  async submitSuKienGia(MaCH: string) {
    await this.sukiengiaService.getSuKienGia(MaCH)
    .then(result => {
      console.log('lấy dữ liệu sự kiện giá thành công');
    })
    .catch(err => {
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/quayban/quayban.component.ts